import React, { useEffect, useState } from "react";
import { Form, Input, Select, DatePicker, Button, message } from "antd";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowCircleLeft } from "react-icons/fa";
import axios from "../../../components/utils/Interceptors";
import postData from "../../../hooks/postData";
import { toast } from "react-toastify";

const { RangePicker } = DatePicker;
const { Option } = Select;

const AddCoupon = () => {
  const { t } = useTranslation();
  const navigate =useNavigate();
  const [form] = Form.useForm();
  const [couponType, setCouponType] = useState("Amount");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const getAllProducts = async () => {
      setLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_APIURL}/vendor/getallproduct`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      const response = res.data;
      if (response.status_code === 200 && response.data) {
        const data = response.data.map(({ product_id, product_name }) => ({
          label: product_name,
          value: product_id,
        }));
        setProducts(data);
      }
      setLoading(false);
    };
    getAllProducts();
  }, []);

  const onFinish = async (values) => {
    const { minimum_purchase_amount, maximum_discount, coupon_type, date_range } = values;

    // Validations
    if (coupon_type === "Amount" && Number(maximum_discount) > Number(minimum_purchase_amount)) {
      toast.error("Discount value can't be greater than minimum purchase price");
      return;
    } else if (coupon_type === "Percentage" && Number(maximum_discount) > 100) {
      toast.error("Discount percentage can't exceed 100%");
      return;
    }

    const [from_date, to_date] = date_range || [];
    const payload = {
      ...values,
      from_date,
      to_date,
    };

    const res = await postData("/vendor/createcoupon", payload);
    if (res.status_code === 200) {
      toast.success(res.message);
      form.resetFields();
    } else {
      toast.error(res.message || res.err);
    }
  };

  return (
    <div className="mb-20">
      <div className="max-w-xl mx-auto border bg-white p-4">
        <div className="card-title border-b pb-4">
          <div className="">
            <h3 className="text-base font-medium">{t("add_coupon_info")}</h3>

            <button onClick={() => navigate("/vendor/coupons")} className="btn btn-primary w-full rounded-md text-white ml-auto">
              <FaArrowCircleLeft />  {t("add_new_product_back")}
            </button>

          </div>
        </div>

        <Form layout="vertical" form={form} onFinish={onFinish} className="mt-5">
          <Form.Item
            label={`${t("add_coupon_code")}`}
            name="coupon_code"
            rules={[{ required: true, message: t("coupon_error1") }]}
          >
            <Input placeholder={t("add_coupon_code")} />
          </Form.Item>

          <Form.Item label={t("add_coupon_type")} name="coupon_type" initialValue="Amount">
            <Select onChange={setCouponType}>
              <Option value="Amount">{t("Amount")}</Option>
              <Option value="Percentage">{t("Percentage")}</Option>
            </Select>
          </Form.Item>

          <Form.Item
            label={t("add_coupon_min_shopping")}
            name="minimum_purchase_amount"
            rules={[{ required: true, message: "Add a minimum purchase amount" }]}
          >
            <Input type="number" placeholder={t("Minimum Amount")} />
          </Form.Item>

          <Form.Item
            label={couponType === "Amount" ? t("add_coupon_max_dis_am") : "Discount Percentage"}
            name="maximum_discount"
            rules={[{ required: true, message: "Add a maximum discount" }]}
          >
            <Input type="number" placeholder={couponType === "Amount" ? t("add_coupon_max_dis_am") : "Discount %"} />
          </Form.Item>

          <Form.Item label={t("coupon_date")} name="date_range" rules={[{ required: true, message: "Select date range" }]}>
            <RangePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item className="text-center">
            {/* <Button type="primary" htmlType="submit">
              {t("vd_pc_btn")}
            </Button> */}
            <button
              className="btn btn-primary w-full rounded-md text-white mt-2"
              type="submit"
            >
              {t("vd_pc_btn")}
            </button>

          </Form.Item>
        </Form>
      </div>
    </div >
  );
};

export default AddCoupon;
